import { DanceManagerSocialLinkTypeEnum } from '../enums';

export interface DanceManagerSocialLinkInterface {
  type: DanceManagerSocialLinkTypeEnum;
  url: string;
}
